module.exports = __webpack_public_path__ + "static/media/05_galeria_plantillas_combo_simple_cuad_3.9d0d75e2.png";